<!-- *************************************************************************
	TEMPLATE
	************************************************************************* -->
<template>
  <div>
    <PageTitle title="Category View" :backBtn="true" />

    <v-container fluid>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-card class="lighten-12">
          <v-card-title class="v-card__title">
            <v-icon color="blue" small>mdi-sale</v-icon
            ><span class="ml-3"> Category Details Details</span>
          </v-card-title>
          <v-container fluid class="container saledetailscard">
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                <v-row class="pt-0">
                  <v-col
                    cols="12"
                    sm="12"
                    md="3"
                    lg="3"
                    class="pr-5pt-1.5 pb-1 reference_number"
                  >
                    <v-icon>mdi-sale</v-icon>
                    {{ category.name }}
                  </v-col>
                  <v-col cols="12" sm="12" md="2" lg="2">
                    <span class="statustext pr-5 font-weight-bold">Code</span>
                    {{ category.code }}
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="1"
                    lg="1"
                    class="shoptext pr-5 pt-0 mt-7"
                  >
                    <v-divider></v-divider>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="2"
                    lg="2"
                    class="shoptext pr-5 pt-0 mt-5"
                  >
                    <v-row class="subtextlable"> Parent Category </v-row>
                    <v-row>
                      {{ category.parent ? category.parent.name : '----' }}
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="1"
                    lg="1"
                    class="shoptext pr-5 pt-0 mt-7"
                  >
                    <v-divider></v-divider>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="3"
                    lg="3"
                    class="shoptext pr-5 pt-0 mt-5"
                  >
                    <v-row class="subtextlable"> Description </v-row>
                    <v-row>
                      {{ category.description }}
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-tabs horizontal background-color="primary" dark>
          <v-tab> Products </v-tab>
          <v-tab-item>
            <ProductList :CategoryId="$route.params.id" />
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="12">
        <AuditLogs :Type="'categories'" />
      </v-col>
    </v-container>
  </div>
</template>

<!-- *************************************************************************
	SCRIPT
	************************************************************************* -->
<script>
import ProductList from './CategoryProductComponent';
//COMPONENTS

export default {
  data() {
    return {
      category: {
        type: Object,
        default: {},
      },
    };
  },

  components: {
    ProductList,
  },
  methods: {
    GetCategory() {
      let categoryId = this.$route.params.id;
      this.$store
        .dispatch('product/GetProductCategory', { id: categoryId })
        .then((res) => {
          this.category = res.data;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetCategory();
  },
};
</script>
<style scoped>
.v-card__title {
  border-bottom: 1px solid lightgray !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  font-size: 16px !important;
  font-weight: lighter !important;
  color: #001e3f;
  font-family: 'Roboto', sans-serif !important;
  font-weight: bold !important;
  padding-left: 20px !important;
  font-family: 'Nunito', sans-serif !important;
}
.purchaseDetail {
  font-weight: bold;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>
